export enum QueuePriority {
  LOW, MEDIUM, HIGH
}

export enum PayrollType {
  NORMAL = 'NORMAL', ON_DEMAND = 'ON_DEMAND', RETROACTIVITY = 'RETROACTIVITY'
}

export enum PayStatus {
  FUTURE = 'FUTURE',
  TODO = 'TODO',
  AGAIN = 'AGAIN',
  SCHEDULED = 'SCHEDULED',
  SENDED = 'SENDED',
  ONGOING = 'ONGOING',
  STORAGE_IN_PROGRESS = 'STORAGE_IN_PROGRESS',
  CALCULATION_DONE = 'CALCULATION_DONE',
  PAYSLIP_IN_PROGRESS = 'PAYSLIP_IN_PROGRESS',
  DONE = 'DONE',
  ALERT = 'ALERT',
  READY = 'READY',
  ERROR = 'ERROR',
  FROZEN = 'FROZEN',
  CLOSED = 'CLOSED'
}

export interface PayExec {
  id: number;
  shortId: number;
  requestPerYear: string;
  beginPeriodDate: string;
  endPeriodDate: string;
  payrollType: PayrollType;
  originPayExecId: number;
  retroDiffPayExecId: number;
  companyName: string;
  payrollSeriesName: string;
  payrollPeriodName: string;
  payRequestId: number;
  priority: QueuePriority;
  recallUntilThisDate: string;
  retroCalculation: boolean;
  generatePaySlip: boolean;
  contractId: number;
  cliCoreId: number;
  payslipPdfFileId: number;
  payslipHtmlFileId: number;
  localeString: string;
  currencyString: string;
  payPeriodContractId: number;
  status: PayStatus;
  nbCriticalAlert: number;
  nbTotalAlert: number;
  nbTotalRules: number;
  nbErrorRules: number;
  nbCalculatedRules: number;
  nbNoCalculatedRules: number;
  retroActivityCalculationCount: number;
  computeDate: string;
  debug: boolean;
  updateDate: string;
  uuidLink: string;
  internationalPayslipAvailable: boolean;
  isToDelete: boolean;
  payGroups: string[];
  payPeriodId: number;
  originPayPeriodId: number;
}
